import './defaultWidgetWrapper.less';

import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { Section } from 'controls/react/layout/section';
import { Toolbar, ToolbarItemsSet } from 'controls/react/layout/toolbar';
import { IconButton } from 'controls/react/form/iconButton';

import { WidgetConfig } from 'controls/designer/features/widgets/widgetConfig';
import { WidgetProps } from 'controls/designer/features/widgets/widgetProps';
import {
	getPresentationMappings,
	PresentationMapping,
} from 'controls/designer/features/ceeview-entity-drop/presentationMappings';
import { CeeviewEntityDragAndDropStore } from 'framework/ceeviewEntityDragAndDropStore';

const b = require('b_').with('dashboard-default-widget-wrapper');

export interface DefaultWidgetWrapperProps<C extends WidgetConfig, P extends object> extends WidgetProps<C, P> {
	toolbarAtTheEnd?: React.ReactNode;
	containerClass?: string;
	children: React.ReactNode;
	showHeader?: boolean;
	headerPosition?: React.CSSProperties;
	contentPadding?: boolean;
}

export const DefaultWidgetWrapper = observer(
	<C extends WidgetConfig, P extends object>(props: DefaultWidgetWrapperProps<C, P>) => {
		let showWidgetHeader =
			props.showHeader !== undefined ? props.showHeader : props.designer.store.viewSettings.showWidgetHeader;

		const isReadOnly = props.designer.config.chromeless;

		showWidgetHeader = showWidgetHeader || !isReadOnly;

		let mappingEntry: PresentationMapping<any>;

		if (CeeviewEntityDragAndDropStore.dragData != null) {
			mappingEntry = getPresentationMappings().find(
				(x) => x.entityType == CeeviewEntityDragAndDropStore.dragData.type && x.widgetType == props.config.type,
			);
		}

		return (
			<Section
				contentPadding={props.contentPadding != null ? props.contentPadding : false}
				height={'fit'}
				appearance={'none'}
				containerClass={classnames(
					props.containerClass,
					b({ 'invalid-drop-target': CeeviewEntityDragAndDropStore.dragData != null && mappingEntry == null }),
				)}
			>
				{showWidgetHeader && (
					<Toolbar title={props.config.title} containerStyle={props.headerPosition}>
						{props.toolbarAtTheEnd}
						<ToolbarItemsSet noPadding>
							{!isReadOnly && <IconButton iconName={'pencil'} embedded={true} onClick={props.actions.editWidget} />}
							{!isReadOnly && <IconButton iconName={'remove'} embedded={true} onClick={props.actions.deleteWidget} />}
						</ToolbarItemsSet>
					</Toolbar>
				)}
				{props.children}
			</Section>
		);
	},
);
